export const routeNames = {
  authCallback: 'auth/callback',
  noRights: 'error403',
  notFound: 'error404',
  portal: 'portal',
  portalBase: '/portal',
  newFileID: 'new',
  draftFileID: 'draft',
  mazCard: 'maz',
  mazLabel: 'maz',
  editor: 'editor',
  editorBase: '/portal/editor',
  impressum: 'impressum',
  datenschutz: 'datenschutz',
  fileLabel: 'file',
  searchQueryTitle: 'queryTitle',
  searchQueryEpisode: 'queryEpisodeNr',
  searchQueryMaz: 'queryMazId',
  contentFormatId: 'format',
  episodeNumber: 'episode',
  paramMazId: 'mazId',
  paramFileNumber: 'fileNumber',
};
